import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section, Title } from 'components/misc'
import { MusicLinks } from 'components/music-links'

export const Music = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="современная музыка">Современная музыка</Title>

      <p>
        В республике сегодня работают множество современных музыкантов, которые берут за основу саха фольклор и язык, но придают им современное звучание. Отдельная особенность местной музыкальной сцены – панк. В регионе существует множество панк-групп, и с каждым годом их число увеличивается. Это музыкальное направление развивается почти в полной изоляции от мировой и российской андеграунд-сцены, но именно эта изоляция помогает создать уникальное звучание саха-панка.
      </p>
      <p>
      Мы собрали подборку современных музыкантов саха, работающих в различных направлениях – от рэпа до панка:
      </p>
    </TextContainer>

    <MusicLinks link="https://music.youtube.com/playlist?list=PL2LCM5HET2HaqYHjrhclWGAQFQK-0kZmn&si=cPzmrk_zhnEJrbRM">
      <span>слушать</span> в YouTube Music
    </MusicLinks>
  </Section>
))
